<template>
    <div class="relative
                h-full">
        <div class="block desktop:flex
                    justify-between
                    desktop:h-full"
             :class="flattenStyle? 'flex-row': 'flex-col'">
            <div class="grid
                        gap-4"
                 :class="flattenStyle? 'mb-2 desktop:mb-0 grid-cols-8 desktop:grid-cols-4': 'mb-6 grid-cols-4'">
                <div v-if="icon"
                     :style="`background-image: url(${icon})`"
                     class="w-full
                            h-16 desktop:h-24
                            mx-auto
                            bg-contain
                            bg-top
                            bg-no-repeat"
                     :class="flattenStyle? 'col-span-2 desktop:col-span-1': ''">
                </div>
                <div :class="(icon ? 'col-span-3 desktop:col-span-3': 'col-span-4 desktop:col-span-4') + (flattenStyle? ' col-span-6 my-auto': '')">
                    <div class="font-bold
                                text-lg
                                mb-1
                                leading-snug"
                         :class="forceRightAlignText && 'text-right'">
                        {{ title }}
                    </div>
                    <div class="text-sm"
                         :class="forceRightAlignText && 'text-right'">
                        <slot />
                    </div>
                </div>
            </div>
            <div class="flex
                        justify-between"
                 :class="flattenStyle? 'flex-row desktop:flex-col': 'flex-row'">
                <PricePerMonth :price="priceToShow"
                               :note="quantity > 0 ? null : priceNote"
                               :showPlus="false" />
                <button v-if="ctaType === 'button'"
                        type="button"
                        class="buyflow-button"
                        :class="{
                            'active': ctaButtonIsSelected,
                            'compressed': ctaButtonMini,
                        }"
                        :disabled="ctaButtonIsDisabled"
                        @click="ctaButtonIsSelected? $emit('deselect'):$emit('select')">
                    <template v-if="ctaButtonIsSelected">
                        <IconCheck class="inline mr-1" />
                        {{ ctaButtonTextSelected }}
                    </template>
                    <template v-else>
                        {{ ctaButtonText }}
                    </template>
                </button>
                <div v-if="ctaType === 'dropdown'"
                     class="buyflow-numeric-select"
                     :class="{ 'active': quantity > 0 }">
                    <select @change="quantityChanged"
                            v-model="quantity"
                            class="edge">
                        <option v-for="(item, index) in new Array(ctaDropdownMax + 1)"
                                :key="index"
                                :value="index">
                            {{ index }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="dividerText"
             class="divider-text
                    absolute
                    top-0 desktop:top-1/2
                    left-1/2 desktop:left-0
                    transform
                    -translate-x-4
                    -translate-y-4
                    w-8
                    h-8
                    text-sm
                    text-gray-400
                    bg-gray-200
                    rounded-full
                    flex
                    justify-center
                    items-center
                    leading-none">
            {{ dividerText }}
        </div>
    </div>
</template>

<script>
    import PricePerMonth from "@/atoms/PricePerMonth"
    import IconCheck from "@/atoms/icons/IconCheck"

    export default {
        name: 'TVServicesUpgrade',
        components: {
            PricePerMonth,
            IconCheck,
        },
        props: {
            flattenStyle: {
                type: Boolean,
                default: false,
            },
            upgradeType: {
                type: String,
                required: true,
                default: null,
            },
            title: {
                type: String,
                required: true,
                default: null,
            },
            icon: {
                type: String,
                default: null,
            },
            price: {
                type: Number,
                required: true,
                default: 0,
            },
            priceNote: {
                type: String,
                default: null,
            },
            ctaType: {
                type: String,
                required: true,
                default: 'button',
                validator: val => [
                    'button',
                    'dropdown',
                ].includes(val)
            },
            ctaButtonText: {
                type: String,
                default: 'Upgrade',
            },
            ctaButtonTextSelected: {
                type: String,
                default: 'Upgraded',
            },
            ctaButtonMini: {
                type: Boolean,
                default: false,
            },
            ctaButtonIsSelected: {
                type: Boolean,
                default: false,
            },
            ctaButtonAllowDeselect: {
                type: Boolean,
                default: false,
            },
            ctaDropdownValue: {
                type: Number,
                default: 0,
            },
            ctaDropdownMax: {
                type: Number,
                default: 1,
            },
            dividerText: {
                type: String,
                default: null,
            },
            forceRightAlignText: {
                type: Boolean,
                default: false,
            },
        },
        data: () => ({
            quantity: 0,
        }),
        computed: {
            priceToShow () {
                return this.quantity > 0 ? this.quantity * this.price : this.price
            },
            ctaButtonIsDisabled() {
                return this.ctaButtonIsSelected && !this.ctaButtonAllowDeselect
            },
        },
        mounted() {
            this.quantity = this.ctaDropdownValue
        },
        methods: {
            quantityChanged() {
                this.$emit('cta-dropdown-changed', this.quantity)
            },
        },
    }
</script>
